<div [className]="mobile ? 'info-box-mobile' : 'info-box'" [fxLayoutAlign]="'start center'">
  <i nz-icon nzType="exclamation-circle" nzTheme="fill"></i>
  <div>
    {{ 'caseValuationDetails.forecastInformation' | translate }}
    <span id="forecastDate" [attr.data-forecast-date]="forecastDate">{{ forecastDate | dateLocale }}</span>
  </div>
</div>
